module.exports = __webpack_public_path__ + "assets/2f44f4d31289a703f27c51cb42f42845.png";